import {
  ContentSection,
  PageSection,
} from "@tiicker/util/lib/contentful/types";
import { Entry } from "contentful";
import React, { useEffect, forwardRef } from "react";
import styles from "./PartnerWithUsTopSection.module.scss";
import Markdown from "components/Markdown/Markdown";
import Button from "components/core/Button/Button";
import { useFlags } from "source/hooks/useFlags";

declare global {
  interface Window {
    hbspt: any;
  }
}
interface Props {
  section: Entry<PageSection>;
  contentSections: Entry<ContentSection>[];
  includes: any;
  onButtonClick: () => void;
}

const PartnerWithUsTopSection = forwardRef(
  (props: Props, ref: React.Ref<HTMLDivElement>) => {
    const flags = useFlags();
    const { whitepaperDownload185008833 } = flags;
    useEffect(() => {
      const script = document.createElement("script");
      script.src = "//js.hsforms.net/forms/embed/v2.js";
      script.async = true;
      document.body.appendChild(script);

      const formInterval = setInterval(() => {
        if (window.hbspt) {
          window.hbspt.forms.create({
            region: "na1",
            portalId: "44182411",
            formId: "8010b0f0-dbec-4913-9859-4a88aabe2217",
            target: "#hubspot-form",
          });
          clearInterval(formInterval);
        }
      }, 100);

      return () => {
        clearInterval(formInterval);
      };
    }, []);

    return (
      <div className={styles.PartnerWithUsTopSection}>
        <div className={styles.PartnerWithUsTopSection__textContainer}>
          {props.contentSections.map((section: Entry<ContentSection>) => {
            return (
              <>
                <h1
                  className={
                    styles.PartnerWithUsTopSection__textContainer__title
                  }
                  dangerouslySetInnerHTML={{
                    __html: section.fields.displayTitle || "",
                  }}
                ></h1>
                <p
                  className={
                    styles.PartnerWithUsTopSection__textContainer__subtitle
                  }
                >
                  {section.fields.textContent}
                </p>
                <Markdown
                  markdownText={section.fields.secondaryTextContent || ""}
                  className={
                    styles.PartnerWithUsTopSection__textContainer__description
                  }
                />
                {whitepaperDownload185008833 && (
                  <Button
                    className={
                      styles.PartnerWithUsTopSection__textContainer__button
                    }
                    type="primary"
                    size="large"
                    onClick={props.onButtonClick}
                  >
                    Whitepaper Download
                  </Button>
                )}
              </>
            );
          })}
        </div>
        <div
          ref={ref}
          className={styles.PartnerWithUsTopSection__formContainer}
        >
          <h4 className={styles.PartnerWithUsTopSection__formContainer__title}>
            Partner with us
          </h4>
          <div id="hubspot-form"></div>
        </div>
      </div>
    );
  }
);

export default PartnerWithUsTopSection;
